var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("div", [
        _c(
          "a",
          {
            staticClass: "button",
            class: _vm.agentButtonClasses,
            attrs: { name: "btnAgent" },
          },
          [_vm._m(0)]
        ),
      ]),
      _c(
        "tippy",
        {
          ref: "tippyAgent",
          attrs: {
            to: "btnAgent",
            arrow: "",
            interactive: true,
            theme: `${_vm.$theme.name}`,
            "max-width": 500,
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "container p-2 is-flex is-justify-content-space-between is-align-content-center",
            },
            [_c("span", { staticClass: "is-size-5" }, [_vm._v("Agent")])]
          ),
          _c("div", { staticClass: "is-divider mb-1 mt-0" }),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Device")]),
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.deviceName,
                        expression: "deviceName",
                      },
                    ],
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.deviceName = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          return _vm.changeDevice()
                        },
                      ],
                    },
                  },
                  _vm._l(_vm.devices, function (device) {
                    return _c("option", { key: device }, [
                      _vm._v(_vm._s(device)),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Resolution")]),
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.resolutionName,
                        expression: "resolutionName",
                      },
                    ],
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.resolutionName = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          return _vm.changeResolution()
                        },
                      ],
                    },
                  },
                  _vm._l(_vm.resolutions, function (resolution) {
                    return _c("option", { key: resolution }, [
                      _vm._v(_vm._s(resolution)),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Pixel Type")]),
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.pixelTypeName,
                        expression: "pixelTypeName",
                      },
                    ],
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.pixelTypeName = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          return _vm.changePixelType()
                        },
                      ],
                    },
                  },
                  _vm._l(_vm.pixelTypes, function (pixelType) {
                    return _c("option", { key: pixelType }, [
                      _vm._v(_vm._s(pixelType)),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-toolbox mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }